import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import TaggedLineStringSimplifier from './TaggedLineStringSimplifier';
import LineSegmentIndex from './LineSegmentIndex';
var TaggedLinesSimplifier = /*#__PURE__*/function () {
  function TaggedLinesSimplifier() {
    _classCallCheck(this, TaggedLinesSimplifier);
    TaggedLinesSimplifier.constructor_.apply(this, arguments);
  }
  _createClass(TaggedLinesSimplifier, [{
    key: "setDistanceTolerance",
    value: function setDistanceTolerance(distanceTolerance) {
      this._distanceTolerance = distanceTolerance;
    }
  }, {
    key: "simplify",
    value: function simplify(taggedLines) {
      for (var i = taggedLines.iterator(); i.hasNext();) this._inputIndex.add(i.next());
      for (var _i = taggedLines.iterator(); _i.hasNext();) {
        var tlss = new TaggedLineStringSimplifier(this._inputIndex, this._outputIndex);
        tlss.setDistanceTolerance(this._distanceTolerance);
        tlss.simplify(_i.next());
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._inputIndex = new LineSegmentIndex();
      this._outputIndex = new LineSegmentIndex();
      this._distanceTolerance = 0.0;
    }
  }]);
  return TaggedLinesSimplifier;
}();
export { TaggedLinesSimplifier as default };